import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray, propTypes } from 'redux-form';
import ToolTip from "../../../common/tooltip";
import BarberSettingsRow from './BarberSettingsRow';
import SaveButton from '../../../common/buttons/saveButton';
import Tooltip from '../../../common/tooltip';
import { minuteOptionShape } from '../../../common/hoc/withMinuteOptions';

const BarberSettingsTable = ({
  handleSubmit,
  submitting,
  override,
  shopBookNoPay,
  minInterval,
  minuteOptionsNoZero,
}) => (
  <div className="c-wrapper c-wrapper-wide">
    <div className="u-margin-auto u-pt-">
      <form onSubmit={handleSubmit}>
        <div className="o-flexbox o-flexbox--column o-flexbox--no-wrap">
          <div className="c-table-card c-table-barber-settings">
            <div className="c-table-card__head c-table-card__head--bottom">
              <div className="c-table-card__cell c-label u-2/20 u-pb0">Barber</div>
              <div className="c-table-card__cell c-label u-1/20 u-pb0" display-if={shopBookNoPay}>
                allow booking w/o payment
              </div>
              <div className="c-table-card__cell c-label u-1/20 u-pb0">
                Booking tip
                <ToolTip text="Displays tipping during the booking flow" />
              </div>
              <div className="c-table-card__cell c-label u-1/20 u-pb0">
                Confirmation tip
                <ToolTip text="Displays tipping on the confirmation page" />
              </div>
              <div className="c-table-card__cell c-label u-1/20 u-pb0">allow multiple services</div>
              <div className="c-table-card__cell c-label u-2/20 u-pb0">client booking interval</div>
              <div className="c-table-card__cell c-label u-2/20 u-pb0">barber booking interval</div>
              <div className="c-table-card__cell c-label u-1/20 u-pb0">days client can book in advance</div>
              <div className="c-table-card__cell c-label u-2/20 u-pb0">
                mins a client can book appt before hand
              </div>
              <div className="c-table-card__cell c-label u-1/20 u-pb0">
                Customer Cancellations
              </div>
              <div className="c-table-card__cell c-label u-2/20 u-pb0">
                mins a clients can cancel before appt time
              </div>
              <div className="c-table-card__cell c-label u-2/20 u-pb0">1st client reminder</div>
              <div className="c-table-card__cell c-label u-2/20 u-pb0">2nd client reminder</div>
            </div>
          </div>
          <div className="u--mt--">
            <FieldArray
              name="shops"
              component={BarberSettingsRow}
              showBookNoPay={shopBookNoPay}
              minInterval={minInterval}
              minuteOptionsNoZero={minuteOptionsNoZero}
            />
          </div>
          <FieldArray
            name="barbers"
            component={BarberSettingsRow}
            showBookNoPay={shopBookNoPay}
            minInterval={minInterval}
            minuteOptionsNoZero={minuteOptionsNoZero}
          />
          <div className="u-pt o-flexbox__item--flex-end c-table-buttons-sticky-right">
            <button
              className="c-btn c-btn--grey u-mr-"
              type="button"
              onClick={handleSubmit(override)}
              disabled={submitting}
            >
                Override barber settings
                <Tooltip
                  className="c-info-tooltip-new--small"
                  text={'Clicking this button will override all barber settings for each barber ' +
                    'with the default settings for the shop set in the first column.'}
                />
            </button>
            <SaveButton
              content="Save"
              disabled={submitting}
            />
          </div>
        </div>
      </form>
    </div>
  </div>
  );

BarberSettingsTable.propTypes = {
  handleSubmit: propTypes.handleSubmit.isRequired,
  submitting: propTypes.submitting.isRequired,
  override: PropTypes.func.isRequired,
  shopBookNoPay: PropTypes.bool.isRequired,
  minInterval: PropTypes.number.isRequired,
  minuteOptionsNoZero: minuteOptionShape.isRequired,
};

export default BarberSettingsTable;
